import { GlobalAppState } from '@model/state';

export const getEarlyFlightsLoading = (state: GlobalAppState) => state.searchResults.earlyFlights.loading;
export const getEarlyFlightsError = (state: GlobalAppState) => state.searchResults.earlyFlights.error;
export const getEarlyFlightsData = (state: GlobalAppState) => state.searchResults.earlyFlights.data;
export const getEarlyFlightsToken = (state: GlobalAppState) => state.searchResults.earlyFlights.token;
